import { Category } from "../category/category";
import { IndexExpense } from "../index-expense";

export class showMediaCalendar{
    categori: Category;
    dataId: IndexExpense;
    constructor (categori,dataId) {
        this.categori = categori;
        this.dataId = dataId;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/show-media-calendar.ts